import ky from 'ky'
import { MINUTE } from '@/shared/constants/time.ts'
import { isGameLocation } from '@/shared/lib/utils/location.ts'
import { isDevelopment } from '@/shared/constants/env.ts'
import { Device } from '@/shared/lib/utils/device.ts'
import { TokenRefresher } from '@/shared/api/TokenRefresher.ts'
import { getAuthStore } from '@/domains/auth/model/store.ts'

export const API_URL = isDevelopment ? 'https://dev-api.lair.fi' : 'https://api.lair.fi'

export interface ApiResponse {
  result: {
    code: number
    message: string
  }
  state: number
  data: unknown
}

export const ERROR_ALREADY_LOGOUT = 3005
export const ERROR_EXPIRED_TOKEN = 4001
export const ERROR_RETRY_LOGIN = 4000

export const httpClient = ky.create({
  headers: { 'content-type': 'application/json' },
  credentials: 'include',
  prefixUrl: API_URL,
  timeout: MINUTE,
  retry: 0,
  hooks: {
    beforeRequest: [
      async _request => {
        const { token } = getAuthStore()
        if (token) {
          _request.headers.set('Authorization', `Bearer ${token}`)
        }

        const deviceId = Device.get()
        if (deviceId) {
          _request.headers.set('x-device-id', deviceId)
        }
      },
    ],
    afterResponse: [
      async (_request, _options, _response) => {
        const json: ApiResponse = await _response.json()

        switch (json.state) {
          case 200: {
            const data = JSON.stringify(json.data)
            return new Response(data, { status: 200 })
          }
          case 401: {
            const authStore = getAuthStore()
            authStore.removeToken()

            switch (json.result.code) {
              case ERROR_EXPIRED_TOKEN: {
                const response = await TokenRefresher.refresh()

                if (response && response.token) {
                  authStore.setToken(response.token)
                  _request.headers.set('Authorization', `Bearer ${response.token}`)
                }

                return httpClient(_request)
              }
              case ERROR_RETRY_LOGIN:
              case ERROR_ALREADY_LOGOUT: {
                if (isGameLocation()) {
                  if (location.pathname !== '/game') {
                    window.location.replace('/game')
                  }
                } else {
                  // window.location.replace('/')
                }
                return
              }
            }
          }
        }

        throw json
      },
    ],
  },
})
